import { useSearchParams } from 'react-router-dom';
import ChangeLogPage from './ChangeLogPage';
import ChangeSetDetailPage from './ChangeSetDetailPage';

const ChangeLogPageWrapper = () => {
    const [searchParams] = useSearchParams();
    const changeLogId = searchParams.get('changeLogId');

    // If there's a changeLogId query parameter, show the detail page
    if (changeLogId) {
        return <ChangeSetDetailPage />;
    }

    // Otherwise show the list page
    return <ChangeLogPage />;
};

export default ChangeLogPageWrapper;
